import { useEffect } from 'react';
export var useClickOutside = function (ref, callback) {
    useEffect(function () {
        var startedInside = false;
        var startedWhenMounted = false;
        var listener = function (event) {
            // Игнорировать событие если `mousedown` или `touchstart` внутри элемента
            if (startedInside || !startedWhenMounted)
                return;
            // Игнорировать если клик по элементу ref или дочерним
            if (!ref.current || ref.current.contains(event.target))
                return;
            callback(event);
        };
        var validateEventStart = function (event) {
            startedWhenMounted = !!ref.current;
            startedInside = !!(ref.current && ref.current.contains(event.target));
        };
        document.addEventListener('mousedown', validateEventStart);
        document.addEventListener('touchstart', validateEventStart);
        document.addEventListener('click', listener);
        return function () {
            document.removeEventListener('mousedown', validateEventStart);
            document.removeEventListener('touchstart', validateEventStart);
            document.removeEventListener('click', listener);
        };
    }, [ref, callback]);
};
